import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_MANL_INFO_FORM } from "@/tra/tancis/ptli/ptl/manl/service/PtliManlService";
import { PTLI0411004Q } from "@/tra/tancis/ptli/ptl/manl/PTLI0411004Q";

/*
 * Manage manual information registration
 * !== 매뉴얼정보관리 등록 ==!
 */
export const PTLI0411002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const pgeTitle = "Manage manual information registration"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manage manual information Form !== 매뉴얼정보관리 Form ==!
        manlInfoForm: useForm({
            defaultSchema: SF_MANL_INFO_FORM,
            // defaultValues: {
            //     ...(pgeStore?.form || {}),
            // },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //  !== 화면 ID로 화면 정보를 가져온다==!
        getScrnInfo: useFetch({
            // api: () =>
            //     return APIS.getScrnInfo(form.manlInfoForm.getValues("scrnId"));
            //     // enabled: comnUtils.isEmpty(form.manlInfoForm.errors),

            api: () => {
                return APIS.getScrnInfo(form.manlInfoForm.getValues("scrnId"));
            },
            onSuccess: (data) => {
                form.manlInfoForm.setValues(data.manlDtlInfo.content);
                form.manlInfoForm.clearErrors("scrnId");
            },
            onError: (error: any) => {
                const { errorMessage } = error.response.data;
                modal.openModal({ content: errorMessage });

                form.manlInfoForm.setValue("scrnNm", null);
                form.manlInfoForm.setValue("bsopClsfCd", null);
                form.manlInfoForm.setValue("ptlTpCd", null);
            },
        }),

        createManlInfo: useFetch({
            api: (data) => APIS.createManlInfo({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onCancel: () => {
                        navigate(`${URLS.ptli0411001q}`);
                    },
                    /*
                    onConfirm: () => {
                        navigate(`${URLS.ptli0411001q}`);
                    },
                    */
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.manlInfoForm.setErrors(error.response.data.errors);
                }

                modal.openModal({ content: error.response.data.errorMessage });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onSearchScrnClick: () => {
            modal.openModal({
                draggable: true,
                size: "md",
                content: <PTLI0411004Q callback={handler.onModalCallback} />,
            });
        },

        onResetScrnClick: () => {
            form.manlInfoForm.setValue("scrnId", null);
            form.manlInfoForm.setEditable("scrnId", true);
        },

        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.manlInfoForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            form.manlInfoForm.handleSubmit(
                () => {
                    const data = form.manlInfoForm.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createManlInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        setCoTinChange: () => {
            const scrnId = form.manlInfoForm.getValue("scrnId");
            form.manlInfoForm.setError("scrnId", {
                message: "msg.ptl.00769",
                type: "error",
            });
        },

        onModalCallback: (data: any) => {
            if (!comnUtils.isEmpty(data)) {
                form.manlInfoForm.setValues(data);
                //fetch.getScrnInfo.fetch();
            }
            modal.closeModal();
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        edit: {},
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.manlInfoForm.schema.scrnId}
                                readOnly={true}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        handler.onSearchScrnClick();
                                    },
                                }}
                                onChange={() => {
                                    handler.setCoTinChange();
                                }}
                            />

                            <Group.Control {...form.manlInfoForm.schema.scrnNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlInfoForm.schema.bsopClsfCd} />
                            <Group.Control {...form.manlInfoForm.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlInfoForm.schema.manlFileIdTz} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlInfoForm.schema.manlFileIdEn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlInfoForm.schema.manlFileIdKo} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0411001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    >
                        {t("B_SAVE")}
                    </Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
